import { useState } from "react";
import { MapLayer } from "../../../deckgl/MapLayer";

const useMapLayers = () => {
    const [mapLayers, setMapLayers] = useState<MapLayer[]>([]);

    const addMapLayer = (layer: MapLayer) => {
        setMapLayers(oldArray => [...oldArray, layer]);
    }

    const addMapLayers = (layers: MapLayer[]) => {
        setMapLayers(oldArray => [...oldArray, ...layers]);
    }
  
    const removeMapLayer = (id: string) => {
        setMapLayers(mapLayers.filter(layer => layer.id !== id))
    }
  
    const clearMapLayers = () => {
        setMapLayers([])
    }

    return { mapLayers, addMapLayer, addMapLayers, removeMapLayer, clearMapLayers }
}

export default useMapLayers;